/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { checkIfValueIsValid } from '../common';

export const getBuildingData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.BUILDING;

  const buildingData = dataSet[factKey] || {};

  const BuildingFactsRow = ({ facts }) => {
    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value}
          </div>
        </div>
      );
    }

    return <></>;
  };

  let fieldsList = [];

  Object.keys(buildingData).forEach((fieldKey, index) => {
    fieldsList.push(
      <BuildingFactsRow
        key={index}
        facts={{
          factFieldName: fieldKey,
          value: buildingData[fieldKey]
        }}
      />
    );
  });

  const BuildingSection = () => {
    return <div className='building-data-body'>{fieldsList}</div>;
  };

  return {
    component: <BuildingSection />,
    factsCount: fieldsList.length
  };
};
